export default function CopyIcon(
  props: Pick<React.SVGProps<SVGSVGElement>, "className">,
) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.28592 1.6665C7.20985 1.6665 6.2545 2.35508 5.91422 3.37593L5.87742 3.48631C5.73188 3.92293 5.96785 4.39487 6.40447 4.54041C6.84109 4.68595 7.31302 4.44998 7.45856 4.01336L7.49535 3.90298C7.60878 3.5627 7.92723 3.33317 8.28592 3.33317H15.8347C16.2949 3.33317 16.668 3.70627 16.668 4.1665V11.7152C16.668 12.0739 16.4385 12.3924 16.0982 12.5058L15.9878 12.5426C15.5512 12.6881 15.3152 13.1601 15.4608 13.5967C15.6063 14.0333 16.0782 14.2693 16.5148 14.1237L16.6252 14.0869C17.6461 13.7467 18.3347 12.7913 18.3347 11.7152V4.1665C18.3347 2.78579 17.2154 1.6665 15.8347 1.6665H8.28592ZM4.16797 5.83317C2.78726 5.83317 1.66797 6.95246 1.66797 8.33317V15.8332C1.66797 17.2139 2.78726 18.3332 4.16797 18.3332H11.668C13.0487 18.3332 14.168 17.2139 14.168 15.8332V8.33317C14.168 6.95246 13.0487 5.83317 11.668 5.83317H4.16797ZM3.33464 8.33317C3.33464 7.87293 3.70773 7.49984 4.16797 7.49984H11.668C12.1282 7.49984 12.5013 7.87293 12.5013 8.33317V15.8332C12.5013 16.2934 12.1282 16.6665 11.668 16.6665H4.16797C3.70773 16.6665 3.33464 16.2934 3.33464 15.8332V8.33317Z"
        fill="#0F1324"
        fillOpacity="0.6"
      />
    </svg>
  );
}
